import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import { DataSourceOptions } from 'devextreme/data/data_source';
import { LoadOptions } from 'devextreme/data/load_options';
import { CommonService } from '../../../../shared/modules/my-common/services/common.service';
import { ConfigService } from '../../../../shared/modules/my-common/services/config.service';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { StateStoreService } from '../../../../shared/modules/my-common/services/state-store.service';
import { ABaseComponent } from '../../../../shared/modules/ui/components/abstract/a-base.component';
import { GridHelperService } from '../../../../shared/modules/ui/services/grid-helper.service';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import { ConsumerApi, LoggerService } from '../../../../shared/sdk';
import { MongoLoadOptionsConverter } from 'src/app/shared/classes/loopback-custom-store/generic/load-options-converters/MongoLoadOptionsConverter';
import { BehaviorSubject, of } from 'rxjs';
import { delay, exhaustMap, takeUntil, tap } from 'rxjs/operators';
import moment from 'moment';

@Component({
  selector: 'app-expiring-trips',
  templateUrl: './expiring-trips.component.html',
  styleUrls: ['./expiring-trips.component.scss'],
})
export class ExpiringTripsComponent extends ABaseComponent implements OnInit, AfterViewInit {
  // isSU$: Observable<boolean>;

  $resize$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  @ViewChild(DxDataGridComponent, { static: true }) grid: DxDataGridComponent;
  grid_stateStoring: any;

  dso: DataSourceOptions;

  pWeeksCol = [1, 2, 3, 4, 5].map(w => ({ name: `${w} Week${w > 1 ? 's' : ''} ago`, value: w }));
  nWeeksCol = [1, 2, 3, 4, 5].map(w => ({ name: `${w} Week${w > 1 ? 's' : ''} from now`, value: w }));
  pWeeks: any = this.pWeeksCol[1].value;
  nWeeks: any = this.nWeeksCol[1].value;
  columns: any[] = [];

  constructor(
    public logger: LoggerService,
    public config: ConfigService,
    public common: CommonService,
    private consumerApi: ConsumerApi,
    private gridHelper: GridHelperService,
  ) {
    super(logger);

    this.grid_stateStoring = {
      enabled: true,
      type: 'localStorage',
      storageKey: '7276d037-36fa-5e37-ab23-32176ee1b3b1',
    };

    this.$resize$
      .pipe(
        exhaustMap(() =>
          of(true).pipe(
            delay(1000),
            tap(() => {
              this.grid && this.grid.instance && this.grid.instance.repaint();
            }),
          ),
        ),
        takeUntil(this.$onDestroy$),
      )
      .subscribe();
  }

  ngOnInit() {
    super.ngOnInit();
    this.dso = this.buildDataSource();
    this.rebuildColumns();
  }

  getTripsClass(cellInfo) {
    if (cellInfo.value === 0) return 'red';
    const weekIdx = parseInt(cellInfo.column.dataField.match(/\d+/)[0], 10);
    const trips = cellInfo.data.weeks[weekIdx] && cellInfo.data.weeks[weekIdx].trips;
    if (!trips || !trips.length) '';
    if (trips.find(t => t.tripStatus === 'S1')) return 'green';
    return 'red';
  }

  getTripsTooltip(cellInfo: any): string {
    const weekIdx = parseInt(cellInfo.column.dataField.match(/\d+/)[0], 10);
    const trips = cellInfo.data.weeks[weekIdx] && cellInfo.data.weeks[weekIdx].trips;
    if (!trips || !trips.length) return 'No trips';
    return trips
      .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
      .map(t => `${moment(t.date).format('MM/DD/YYYY')}: ${t.tripId}: ${t.tripStatus || ''}`)
      .join('\n');
  }

  onWeeksChanged() {
    this.rebuildColumns();
    this.grid.instance.refresh();
  }

  rebuildColumns() {
    this.columns = [
      { dataField: 'firstName', caption: 'First Name' },
      { dataField: 'lastName', caption: 'Last Name' },
      { dataField: 'mci', caption: 'MCI' },
      { dataField: 'consumer.person_dob', caption: 'DOB', dataType: 'date' },
      { dataField: 'consumer.activeMco', caption: 'Active MCO' },
      { dataField: 'consumer.lastEligibility', caption: 'Last Eligibility' },
      { dataField: 'consumer.lastEligibilityDate', caption: 'Last Eligibility Date', dataType: 'date' },
    ];
    for (let i = 0; i < this.pWeeks; i++) {
      this.columns.push({
        dataField: `weeks[${i}].tripsCount`,
        caption: `${this.pWeeksCol[this.pWeeks - i - 1].name}`,
        cellTemplate: 'trips',
      });
    }
    for (let i = 0; i < this.nWeeks; i++) {
      this.columns.push({
        dataField: `weeks[${this.pWeeks + i}].tripsCount`,
        caption: `${this.nWeeksCol[i].name}`,
        cellTemplate: 'trips',
      });
    }
  }

  repaint(): void {
    this.grid && this.grid.instance && this.grid.instance.repaint();
  }

  grid_onInitialized(e) {
    // !!! important to handle grid initialization, it will set up the grid options and styles
    this.gridHelper.handle(e.component, {
      notifyErrors: true,
    });
  }

  grid_onToolbarPreparing(e) {
    e.toolbarOptions.items.push({
      ...{ name: 'refresh', locateInMenu: 'auto', location: 'after', widget: 'dxButton', showText: 'inMenu' },
      options: { icon: 'refresh', text: 'Refresh', hint: 'Refresh', onClick: () => e.component.refresh() },
    });
  }

  ngAfterViewInit(): void {}

  private buildDataSource() {
    const store = new CustomStore({
      useDefaultSearch: true,
      cacheRawData: false,
      load: async (loadOptions: LoadOptions): Promise<any> => {
        let q = new MongoLoadOptionsConverter().convert(loadOptions);
        // if (Object.keys(q).length === 0) return [];
        return this.consumerApi.getExpiringTrips({ q }, this.pWeeks, this.nWeeks).toPromise();
      },
      byKey: async (key: any | string | number): Promise<any> => {
        const q = { where: { _id: key } };
        return this.consumerApi.getExpiringTrips({ q }, this.pWeeks, this.nWeeks).toPromise();
      },
      totalCount: async (loadOptions: LoadOptions): Promise<number> => {
        let q = new MongoLoadOptionsConverter().convert(loadOptions);
        return this.consumerApi.getExpiringTrips({ q }, this.pWeeks, this.nWeeks, true).toPromise();
      },
    });

    return { store } as DataSourceOptions;
  }

  calculateYesFilterExpression = function (val, op, target) {
    return [this.dataField, ((op === '<>' || op === 'notcontains') && '<>') || '=', 'yes'.includes(val.toLowerCase())];
  };
}
